<div class="h-full bg-white overflow-y-auto">

  <!-- Action Bar -->
  <div class="flex items-center gap-2.5 py-4 px-7 border-b border-[var(--app-base)] flex-wrap">
    <!-- Left buttons -->
    <button (click)="openBackDialog()"
      class="py-1.5 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">arrow_back</span> BACK
    </button>

    <button (click)="openDeleteSeasonDialog()"
      class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--notification-error)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">delete</span> DELETE
    </button>

    <button (click)="openEditSeasonDialog()"
      class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      EDIT SEASON
    </button>

    <button *ngIf="isSaveBtnVisible" (click)="openSaveFieldDetailsDialog()"
      [disabled]="cultivarSizeInvalid"
      [title]="cultivarSizeInvalid ? 'Fix the cultivar size before saving' : ''"
      class="py-1.5 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)]">
      SAVE
    </button>

    <div class="flex-1"></div>

    <!-- Right side -->
    <button (click)="openEndSeasonDialog()"
      class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--notification-success)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      END SEASON
    </button>

    <div class="flex items-center gap-0 ml-2">
      <span class="text-[11px] font-semibold text-[var(--base-text-alt-dark)] px-3 py-1.5">{{seasonDetails?.status ?? '-'}}</span>
      <span class="text-[11px] font-semibold text-white bg-[var(--primary-dark)] rounded-lg px-3 py-1.5">Status</span>
    </div>
  </div>

  <!-- Season Details -->
  <div class="px-7 py-4">
    <div class="flex items-baseline gap-2 flex-wrap">
      <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Season Name:</span>
      <span class="text-[15px] font-medium text-[var(--base-text-alt-dark)]">{{seasonDetails?.name ?? placeholder}}</span>
    </div>
    <div class="flex items-center gap-1 mt-2 text-[12px] text-[var(--base-text-alt-dark)] flex-wrap">
      <span class="font-bold">Date Created:</span>
      <span class="font-medium">{{seasonDetails ? dayjs(seasonDetails.dateCreated).format(dateStringFormatting) : placeholder}}</span>
      <span class="mx-1.5 text-[var(--app-border)]">|</span>
      <span class="font-bold">Season Start Date:</span>
      <span class="font-medium">{{seasonDetails ? dayjs(seasonDetails.startDate).format(dateStringFormatting) : placeholder}}</span>
      <span class="mx-1.5 text-[var(--app-border)]">|</span>
      <span class="font-bold">Season End Date:</span>
      <span class="font-medium">{{seasonDetails ? dayjs(seasonDetails.endDate).format(dateStringFormatting) : placeholder}}</span>
      <span class="mx-1.5 text-[var(--app-border)]">|</span>
      <span class="font-bold">Total Fields/Camps:</span>
      <span class="font-medium">{{seasonDetails?.totalFields ?? '-'}}</span>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="flex gap-0 px-7 border-b border-[var(--app-base)]">
    <a routerLink="season-admin" queryParamsHandling="preserve" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
      class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Admin</a>
    <a routerLink="sample-batch-update" queryParamsHandling="preserve" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
      [routerLinkActiveOptions]="{exact: true}"
      class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Batch Update</a>
    <a routerLink="costing" queryParamsHandling="preserve" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
      [routerLinkActiveOptions]="{exact: true}"
      class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Batch Costing</a>
    @if(seasonDataTableFlag) {
      <a routerLink="data-table" queryParamsHandling="preserve" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        [routerLinkActiveOptions]="{exact: true}"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Data Table</a>
      <!--
        Behind the same flag as Data Table rather than its own: it is the same body of Season
        Manager work, and it is only useful on a season whose fields are already managed here.
      -->
      <a routerLink="field-order" queryParamsHandling="preserve" routerLinkActive="!text-[var(--primary-dark)] !border-[var(--primary-dark)]"
        [routerLinkActiveOptions]="{exact: true}"
        class="py-3 px-5 text-[13px] font-semibold text-[var(--tertiary-text)] cursor-pointer border-b-2 border-transparent hover:text-[var(--primary-dark)] no-underline transition-colors">Field Order</a>
    }
  </div>

  <!-- Child Route Content -->
  <router-outlet (activate)='setCurrentComponent($event)'></router-outlet>

</div>
